const brandtrans =[
    {
        english: "Essence",
        persian: "اسنس",
        value:'essence',
        index:2,
        color: "rgb(17, 141, 87)",
        background: "rgba(34, 197, 94, 0.16)"
    },
    {
        english: "Revo",
        persian: "روو",
        value:'revo',
        index:3,
        color: "rgb(183, 110, 0)",
        background: "rgba(255, 171, 0, 0.16)"
    },
    {
        english: "Kodak",
        persian: "کداک",
        value:'kodak',
        index:2,
        color: "rgb(17, 141, 87)",
        background: "rgba(34, 197, 94, 0.16)"
    },
    {
        english: "MGMPlus",
        persian: "ام جی ام پلاس",
        value:'mgmplus',
        index:2,
        color: "rgb(17, 141, 87)",
        background: "rgba(34, 197, 94, 0.16)"
    }

]
export default brandtrans